<div class="ds admin-perms roles-page">
	<div class="wrap">
		<div class="op-head adm-head">
			<button type="button" class="back" routerLink="/admin" [attr.aria-label]="'common.back' | translate"><mat-icon>arrow_back</mat-icon></button>
			<div>
				<p class="eyebrow">{{ "header.menu.admin" | translate }}</p>
				<h1>{{ "roles.title" | translate }}</h1>
				<p class="opx-sub">{{ "roles.desc" | translate }}</p>
			</div>
		</div>

		<!-- ============ Asignar perfiles a un usuario ============ -->
		<section class="card-block">
			<h2 class="block-title">{{ "roles.assign.title" | translate }}</h2>

			<app-user-search
				class="user-picker"
				[users]="userList"
				[label]="'admin.adminUser' | translate"
				[placeholder]="'admin.userSearch.placeholder' | translate"
				(userSelected)="onUserSelected($event)"
			></app-user-search>

			<div *ngIf="selectedUser" class="assign-body">
				<h3 class="sub">{{ "roles.assign.current" | translate }}</h3>
				<div class="chips">
					<span class="chip" *ngFor="let p of userPerfiles">
						{{ p.descripcion }}
						<button
							type="button"
							class="chip-x"
							[title]="'roles.assign.remove' | translate"
							(click)="removePerfil(p.id)"
						>
							<mat-icon>close</mat-icon>
						</button>
					</span>
					<p *ngIf="!userPerfiles.length" class="muted">
						{{ "roles.assign.none" | translate }}
					</p>
				</div>

				<div class="add-row">
					<app-ds-select
						class="assign-select"
						[label]="'roles.assign.pick' | translate"
						[(ngModel)]="perfilToAssign"
						[options]="perfilesAsignables"
						[optionLabel]="descripcionOf"
					></app-ds-select>
					<button
						class="btn btn-primary btn-sm"
						[disabled]="!perfilToAssign"
						(click)="addPerfil()"
					>
						<span class="ic"><mat-icon [inline]="true">add</mat-icon></span>
						{{ "roles.assign.add" | translate }}
					</button>
				</div>
			</div>
		</section>

		<!-- ============ Catálogo de perfiles ============ -->
		<section class="card-block">
			<div class="sec-head-row">
				<h2 class="block-title">{{ "roles.list.title" | translate }}</h2>
				<button class="btn btn-primary btn-sm" (click)="newPerfil()">
					<span class="ic"><mat-icon [inline]="true">add</mat-icon></span>
					{{ "roles.list.new" | translate }}
				</button>
			</div>

			<table class="perfiles-table">
				<thead>
					<tr>
						<th>{{ "roles.col.codigo" | translate }}</th>
						<th>{{ "roles.col.descripcion" | translate }}</th>
						<th>{{ "roles.col.alcance" | translate }}</th>
						<th>{{ "roles.col.politicas" | translate }}</th>
						<th>{{ "roles.col.activo" | translate }}</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let p of perfiles">
						<td>{{ p.codigo }}</td>
						<td>{{ p.descripcion }}</td>
						<td>
							{{ (p.necesitaScope ? "roles.scope.scoped" : "roles.scope.global") | translate }}
						</td>
						<td>{{ p.policies.length }}</td>
						<td>{{ (p.activo ? "common.yes" : "common.no") | translate }}</td>
						<td class="actions">
							<button
								type="button"
								class="link-btn"
								(click)="editExisting(p)"
							>
								<mat-icon>edit</mat-icon>
							</button>
						</td>
					</tr>
				</tbody>
			</table>

			<!-- Editor -->
			<div *ngIf="editPerfil" class="editor">
				<h3 class="sub">
					{{ (isNew ? "roles.editor.new" : "roles.editor.edit") | translate }}
				</h3>

				<div class="editor-fields">
					<div class="ff-field">
						<label>{{ "roles.col.codigo" | translate }}</label>
						<div class="ff-box" [class.is-readonly]="!isNew">
							<input
								[value]="editPerfil.codigo"
								[disabled]="!isNew"
								(input)="editPerfil.codigo = $any($event.target).value"
							/>
						</div>
					</div>

					<div class="ff-field">
						<label>{{ "roles.col.descripcion" | translate }}</label>
						<div class="ff-box">
							<input
								[value]="editPerfil.descripcion"
								(input)="editPerfil.descripcion = $any($event.target).value"
							/>
						</div>
					</div>
				</div>

				<div class="editor-toggles">
					<app-ds-toggle
						[checked]="editPerfil.necesitaScope"
						(checkedChange)="editPerfil.necesitaScope = $event"
						[label]="'roles.editor.necesitaScope' | translate"
					></app-ds-toggle>
					<app-ds-toggle
						*ngIf="!isNew"
						[checked]="editPerfil.activo"
						(checkedChange)="editPerfil.activo = $event"
						[label]="'roles.editor.activo' | translate"
					></app-ds-toggle>
				</div>

				<h4 class="sub">{{ "roles.editor.politicas" | translate }}</h4>
				<div class="policies-grid">
					<app-ds-checkbox
						*ngFor="let pol of politicas"
						[checked]="isPolicySelected(pol.codigo)"
						(checkedChange)="togglePolicy(pol.codigo, $event)"
					>
						<span class="pol-code">{{ pol.codigo }}</span>
						<span class="pol-desc">{{ pol.descripcion }}</span>
					</app-ds-checkbox>
				</div>

				<div class="editor-actions">
					<button class="btn btn-ghost btn-sm" (click)="cancelEdit()">
						<span class="ic"><mat-icon [inline]="true">close</mat-icon></span>
						{{ "common.cancel" | translate }}
					</button>
					<button
						class="btn btn-primary btn-sm"
						[disabled]="!canSavePerfil"
						(click)="savePerfil()"
					>
						<span class="ic"><mat-icon [inline]="true">save</mat-icon></span>
						{{ "common.save" | translate }}
					</button>
				</div>
			</div>
		</section>
	</div>
</div>
